var $ = require('jquery');

module.exports = function (_super)
{
    this.tabElementId = 'eh-settings';

    var self = this;

    var $eh = _super.$eh,
        $ehe = _super.$ehe,
        $eheContent = _super.$eheContent,
        optionControlMapper = {},
        zoomSliderId = '#eh-bg-zoom-slider',
        horPosSliderId = '#eh-bg-pos-hor-slider',
        vertPosSliderId = '#eh-bg-pos-vert-slider',
        rotateSliderId = '#eh-bg-rotate',
        brightnessSliderId = '#eh-bg-brightness',
        sharpenSliderId = '#eh-bg-sharpen',
        calculations = window.diy.cms.PictureManipulation.Calculations
    ;

    this.model = _super.model;

    this.init = function()
    {
        var setBackgroundEditedTrue = function() {
            self.model.setBackgroundEdited(1);
        };
        _super.initSlider({option: 'backgroundZoom', id: zoomSliderId,
            min: 100, max: this.model.getBackgroundMaxZoom(),
            step: 0.1,
            formatter: function (val) {
                return val + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);

        _super.initSlider({option: 'backgroundHorPos', id: horPosSliderId,
            min: 0, max: 100,
            step: 0.1,
            formatter: function (val) {
                return Math.round(val*10)/10 + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model, true /* invertValue */);

        _super.initSlider({option: 'backgroundVertPos', id: vertPosSliderId,
            min: 0, max: 100,
            step: 0.1,
            formatter: function (val) {
                return Math.round(val*10)/10 + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);

        _super.initSlider({option: 'rotate', id: rotateSliderId,
            min: -45, max: 45, step: 0.1,
            formatter: function (val) {
                return calculations.mapRotation(val, false) + '°';
            },
            getMapper: function(val) {
                return calculations.mapRotation(val, false);
            },
            setMapper: function(val) {
                return calculations.mapRotation(val, true);
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);

        _super.initSlider({option: 'brightness', id: brightnessSliderId,
            min: -40, max: 40, step: 10,
            formatter: function (val) {
                return val + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);

        _super.initSlider({option: 'sharpen', id: sharpenSliderId,
            min: -40, max: 40, step: 10,
            formatter: function (val) {
                return val + '%';
            },
            onSlide: setBackgroundEditedTrue
        }, optionControlMapper, this.model);
        
        $eheContent.find('.eh-bg-content').diy_simpleTabs({
            activeTabCls: 'diy-tabs-item-selected ui-icon-hover'
        });

    };

    this.updateView = function(model, data, changed)
    {
        var val;
        for(var option in changed) {
            val = changed[option];
            switch(option) {
                case 'backgroundOriginalWidth':
                case 'backgroundOriginalHeight':
                case 'height':
                case 'width':
                case 'backgroundZoom':
                case 'backgroundSourceType':
                case 'backgroundAnimated':
                    var backgroundSourceType = model.getBackgroundSourceType(),
                        uploadedImageId = model.getUploadedImageId(),
                        backgroundAnimated = model.getBackgroundAnimated();

                    var disableBrightSharp = backgroundSourceType == 'Patterns' || backgroundAnimated,
                        disableRotate = backgroundAnimated,
                        disableVertPosSlider = backgroundAnimated,
                        disableHorPosSlider = backgroundAnimated,
                        disableZoomSlider = backgroundAnimated,
                        disableAllSliders = backgroundSourceType == 'ImageUpload' && uploadedImageId == -1,
                        origWidth = model.getBackgroundOriginalWidth(),
                        origHeight = model.getBackgroundOriginalHeight(),
                        width = model.getWidth(),
                        height = model.getHeight(),
                        maxZoom = model.getBackgroundMaxZoom()
                    ;

                    if (model.getBackgroundZoom() == 100) {
                        if (width / origWidth > height / origHeight) {
                            disableHorPosSlider = true;
                        } else {
                            disableVertPosSlider = true;
                        }
                    } else {
                        disableHorPosSlider = disableVertPosSlider = false;
                    }

                    if (width / origWidth > height / origHeight) {
                        if(origWidth * maxZoom / 100.0 < width) {
                            disableZoomSlider = true;
                        }
                    } else {
                        if(origHeight * maxZoom / 100.0 < height) {
                            disableZoomSlider = true;
                        }
                    }

                    $(horPosSliderId)
                        .diy_slider('option', 'disabled', disableHorPosSlider || disableAllSliders);

                    $(vertPosSliderId)
                        .diy_slider('option', 'disabled', disableVertPosSlider || disableAllSliders);

                    $(zoomSliderId)
                        .diy_slider('option', 'disabled', disableZoomSlider || disableAllSliders);

                    $(rotateSliderId).diy_slider('option', 'disabled', disableRotate || disableAllSliders);

                    $(brightnessSliderId)
                        .add($(sharpenSliderId))
                        .diy_slider('option', 'disabled', disableBrightSharp || disableAllSliders);

                    // Show/hide the animated gif info text
                    $('#eh-tabs .eh-bg-animated-info')[backgroundAnimated ? 'show' : 'hide']();
                    $('#eh-bg-image-editor-control')[backgroundAnimated ? 'addClass' : 'removeClass']('hasAnimatedWarning');

                    break;

                default:
                    break;
            }
            var value = changed[option];
            if(optionControlMapper[option]) {
                optionControlMapper[option].setValue(value);
            }
        }
    };


    this.destroy = function()
    {
        // TODO
    };
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/emotion-header/CC.EmotionHeader.Settings.js
 ** module id = 875
 ** module chunks = 0
 **/